// extracted by mini-css-extract-plugin
export default {"hr":"hr___caa7317a3c8dcaab50ad"};